import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";

import BaseModal from "./BaseModal";
import ModelSchema from "../../schemas/model.schema";
import { validate } from "../../utils/ValidationHelpers";
import ParametersForm from "../Cards/ParametersForm";

const ParameterSettingsModal = ({
    isVisible,
    setIsVisible,
    parameterSettings,
    setParameterSettings,
    activeUnit,
    setActiveUnit,
    action,
    isSubmitting,
    setIsFormValid,
    isFormSubmitted,
    getParameterSettingsValue,
    isDynamicSorted,
}) => {
    const [error, setError] = useState({});

    const { t } = useTranslation();

    useEffect(() => {
        validate(
            parameterSettings,
            ModelSchema.ParametersSettings,
            setIsFormValid,
            setError
        );
    }, [parameterSettings]);

    return (
        <BaseModal
            isVisible={isVisible}
            setIsVisible={setIsVisible}
            isSubmitting={isSubmitting}
            titleIcon="fas fa-cog"
            title={t("parameterSettings")}
            contentStyles={{ padding: 0 }}
            action={{
                submitAction: action,
                disabled:
                    (!getParameterSettingsValue("parameterDetails", "unit") &&
                        !getParameterSettingsValue(
                            "parameterDetails",
                            "decimalPlaces"
                        ) &&
                        !getParameterSettingsValue("technicalName")) ||
                    isSubmitting,
            }}
            isSmall={true}
        >
            <div className="w-full h-full">
                <div className="h-86 overflow-y-scroll border small-scroll-y small-scroll-x">
                    <div className="p-3 mr-3">
                        <ParametersForm
                            parameters={parameterSettings}
                            setParameters={setParameterSettings}
                            activeUnit={activeUnit}
                            setActiveUnit={setActiveUnit}
                            error={error}
                            isFormSubmitted={isFormSubmitted}
                            isEdit={true}
                            isDynamicSorted={isDynamicSorted}
                        />
                    </div>
                </div>
            </div>
        </BaseModal>
    );
};

export default ParameterSettingsModal;
